function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M216.802 53.8027C216.802 53.8027 216.802 66.8209 216.802 66.7259H234.093C234.093 66.7721 234.079 53.8027 234.093 53.8027C234.079 53.8027 242.568 53.8027 242.655 53.8027C242.655 53.8027 242.686 86.0887 242.655 86.1234C242.647 86.1234 234.105 86.1234 234.093 86.1234C234.093 86.1234 234.093 71.9426 234.093 71.9005C234.093 71.9426 216.802 71.9005 216.802 71.9005C216.817 71.9551 216.802 86.1318 216.802 86.1234H208.242C208.242 86.1234 208.296 53.8027 208.242 53.8027H216.802Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M135.557 53.8027C135.557 53.8987 135.557 59.3031 135.557 59.3031H122.469V86.1234H113.907V59.3031H100.821C100.821 59.3031 100.838 53.8068 100.821 53.8027C100.839 53.8068 135.557 53.8027 135.557 53.8027Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M148.478 59.3031L142.524 73.9975H154.441L148.478 59.3031ZM168.834 86.1234C168.856 86.1234 159.236 86.1234 159.305 86.1234C159.319 86.1234 156.498 79.1741 156.498 79.1741H140.456C140.456 79.1741 137.704 86.1311 137.655 86.1234C137.661 86.1311 128.127 86.1234 128.127 86.1234L143.228 53.8027C143.228 53.8243 153.729 53.8027 153.729 53.8027L168.834 86.1234Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M258 53.8027H249.434V86.1234H258V53.8027Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M56.5631 53.8027C56.5631 53.8027 56.5584 66.8209 56.5631 66.7259H73.8434C73.8434 66.7721 73.8383 53.8027 73.8434 53.8027C73.8383 53.8027 82.3166 53.8027 82.4105 53.8027C82.4105 53.8027 82.4321 86.0887 82.4105 86.1234C82.3998 86.1234 73.8521 86.1234 73.8434 86.1234C73.8434 86.1234 73.8434 71.9426 73.8434 71.9005C73.8434 71.9426 56.5631 71.9005 56.5631 71.9005C56.5668 71.9551 56.5584 86.1318 56.5631 86.1234H48C48 86.1234 48.0482 53.8027 48 53.8027H56.5631Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M97.7542 53.8027H89.2002V86.1234H97.7542V53.8027Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M168.527 77.1637C167.777 74.9963 167.374 72.708 167.374 70.2836C167.374 66.89 167.978 63.5975 169.605 60.8719C171.276 58.0584 173.845 55.8809 176.951 54.72C179.913 53.6121 183.094 53 186.437 53C190.282 53 193.925 53.8438 197.239 55.2806C200.326 56.6031 202.659 59.3907 203.345 62.7503C203.483 63.4122 203.595 64.1011 203.652 64.79H194.669C194.634 63.9353 194.494 63.0753 194.199 62.3022C193.521 60.5145 192.035 59.1289 190.186 58.5677C188.998 58.2026 187.741 58.0092 186.437 58.0092C184.946 58.0092 183.52 58.2716 182.199 58.7415C180.008 59.5086 178.295 61.2866 177.528 63.4786C176.779 65.6076 176.349 67.9019 176.349 70.2836C176.349 72.2522 176.67 74.1549 177.175 75.9578C177.819 78.3165 179.588 80.204 181.844 81.0599C183.279 81.5969 184.817 81.9179 186.437 81.9179C187.818 81.9179 189.143 81.706 190.398 81.3015C192.068 80.7726 193.431 79.5336 194.14 77.948C194.612 76.8879 194.843 75.7156 194.843 74.4766H203.861C203.81 75.5246 203.665 76.5695 203.429 77.5451C202.66 80.7406 200.42 83.4193 197.443 84.6738C194.056 86.0971 190.35 86.9207 186.437 86.9207C183.408 86.9207 180.492 86.4417 177.755 85.5844C173.579 84.2645 169.963 81.2597 168.527 77.1637Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoHitachi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHitachi);
export default __webpack_public_path__ + "static/media/logo_hitachi.4700751c.svg";
export { ForwardRef as ReactComponent };